export default {
  methods: {
    async addLead(name, phone) {
      const payload = {
        communityData: {
          communityName: "dogkart"
        },
        leadSource: "Whatsapp",
        firstName: name,
        phone: phone
      };

      const result = await this.$store.dispatch("lead/addLead", payload);
    }
  }
};
